import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Sun, Lock } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (user && user.role === "admin") return <Navigate to="/admin" replace/>;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1F15] p-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-[#FDB813] flex items-center justify-center">
            <Sun weight="fill" size={28} className="text-[#0A1F15]"/>
          </div>
        </div>
        <div className="bg-white rounded-3xl p-8 shadow-2xl">
          <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#135934] mb-2">
            <Lock size={14}/> ADMIN LOGIN
          </div>
          <h1 className="font-display font-extrabold text-3xl text-[#0A1F15] mb-1">Orax Solar Admin</h1>
          <p className="text-sm text-[#5C7368] mb-6">Sign in to manage your website</p>

          <form onSubmit={onSubmit} className="space-y-3" data-testid="admin-login-form">
            <input
              type="email"
              required
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="input-solar w-full px-4 py-3 rounded-xl border border-[#E5E3DB]"
              data-testid="admin-email-input"
            />
            <input
              type="password"
              required
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="input-solar w-full px-4 py-3 rounded-xl border border-[#E5E3DB]"
              data-testid="admin-password-input"
            />
            <button
              type="submit"
              disabled={busy}
              className="btn-primary w-full disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {busy ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
        <p className="text-center text-white/60 text-xs mt-4">
          Authorized personnel only. All actions are logged.
        </p>
      </div>
    </div>
  );
}
